module.exports = __webpack_public_path__ + "img/logo-round.b5d3e82e.png";